import React, { useState } from "react";
import { sendEmail } from "../../hooks/services/api-services";
import { toastEmitter, validateRegex } from "../../utils/utilities";
import { EmailRegex } from "../../utils/regexValidation";
import { LOGO_ICON } from "../../utils/aap-image-constant";

const RequestVerification = () => {
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {

    if (!email) {
      toastEmitter("error", "Please enter email");
      return;
    }
    if (!validateRegex(email, EmailRegex)) {
      return toastEmitter("error", "Email is invalid!");
    }
    if (!type) {
      toastEmitter("error", "Please select user type");
      return;
    }

    try {
      setLoading(true);
      const res = await sendEmail(email, type);
      if (res?.data?.status === 200) {
        toastEmitter("success", "User delete request sent to your email");
        setEmail("");
        setType("");
      } else {
        toastEmitter("error", res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      toastEmitter("error", err?.response?.data?.message || "Failed to send link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "#f4f8ff",
      }}
    >
      <div
        className="shadow-lg p-4 rounded-4 bg-white"
        style={{
          width: "380px",
        }}
      >
        <div className="text-center mb-3">
          <img
            src={LOGO_ICON}
            alt=""
            className="logoimg"
          />
        </div>

        {/* Heading */}
        <div className="text-center mb-3">
          <h3 style={{ fontWeight: "600" }}>
            Request Account Deletion
          </h3>
          <p style={{ fontSize: "14px", color: "#777" }} className="mt-1">
            Enter your details to receive a deletion link
          </p>
        </div>

        {/* Email Input */}
        <div className="mb-2">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            className="form-control rounded-3"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {/* User Type */}
        <div className="mb-4">
          <label className="form-label">User Type</label>
          <select
            className="form-select rounded-3"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">Select User Type</option>
            <option value="DOCTOR">Doctor</option>
            <option value="PATIENT">Patient</option>
          </select>
        </div>

        {/* Button */}
        <button
          className="btn w-100 rounded-3"
          onClick={handleSubmit}
          disabled={loading}
          style={{
            background: "#2a6df5",
            color: "#fff",
            fontWeight: "500",
            padding: "10px",
          }}
        >
          {loading ? "Sending..." : "Send Deletion Link"}
        </button>
      </div>
    </div>
  );
};

export default RequestVerification;